import * as THREE from 'three';

export default class RenderController {

    private readonly uuid: string;
    private readonly scene: THREE.Scene;
    private timer: number = 0;

    constructor(scene: THREE.Scene) {
        this.uuid = crypto.randomUUID();
        this.scene = scene;
    }

    public update(deltaTime: number): void {

        this.timer += deltaTime;

        if (this.timer > 1000) {
            this.timer = 0;

            let objects = 0;
            let vertices = 0;
            let triangles = 0;
            let meshes = 0;

            this.scene.children.forEach(x => {
                x.traverseVisible(x => {

                    objects++;

                    if (x instanceof THREE.Mesh) {

                        meshes++;

                        const geometry = x.geometry;

                        vertices += geometry.attributes.position.count;

                        if (geometry.index !== null) {
                            triangles += geometry.index.count / 3;
                        }
                        else {
                            triangles += geometry.attributes.position.count / 3;
                        }
                    }
                });
            });

            console.log({
                uuid: this.uuid,
                objects,
                meshes,
                vertices,
                triangles,
            });
        }
    }
}